<template>
    <div class="comment-section">
      <div class="comment-list" v-if="comments.length > 0">
        <div v-for="(comment, index) in comments" :key="index" class="comment">
          <p> {{ comment.text }}</p>
          <p class="timestamp"> <i>{{ comment.user }}</i>  {{ comment.timestamp }}</p>
        </div>
      </div>
        <div v-else>
            <p>No hay comentarios</p>
        </div>
  
      <div class="comment-input">
        <textarea v-model="newCommentText" @keyup.enter="addComment" placeholder="Escribe tu comentario..."></textarea>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name:"CommentSectionComponent",
    data() {
      return {
        // List of comments
        comments: [],
        // Text for the new comment
        newCommentText: '',
        // Placeholder for user name
      };
    },
    props: {
      userName: {
        type: String,
        default: 'Guest'
      },
      value: {
        type: Array,
        default: () => []
      }

    },
    methods: {
      // Method to add a comment
      addComment() {
        if (this.newCommentText.trim()) {
          const newComment = {
            user: this.userName, // Can be dynamic, e.g., from a store or login system
            text: this.newCommentText.trim(),
            timestamp: new Date().toLocaleString()
          };
  
          // Push the new comment to the list
          this.comments = [...this.comments, newComment];
  
          // Clear the input field after adding the comment
          this.newCommentText = '';
          this.$emit('input', this.comments);
          this.$emit('new-comment');
        }
      }
    },
    mounted() {
      // Set the initial comments
      this.comments = this.value;
    },
  };
  </script>
  
  <style scoped>
  .comment-section {
    max-width: 600px;
    margin: 0 auto;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 8px;
  }
  
  .comment-list {
    margin-bottom: 10px;
  }
  
  .comment {
    background-color: #fff;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .timestamp {
    font-size: 0.85em;
    color: #888;
    margin-top: 5px;
  }
  
  .comment-input textarea {
    width: 100%;
    height: 80px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1em;
    resize: none;
    box-sizing: border-box;
  }
  </style>
  